import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

try {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
    enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),

    enableLogs: true,
    enableMetrics: true,

    tracesSampleRate: 0.2,
  });
} catch (e) {
  console.error("Sentry initialization failed:", e);
}

createRoot(document.getElementById("root")!).render(<App />);
